import MapStore from 'app/src/editor/MapStore';
import { createContext, useContext } from 'react';

type MapStoreContext = {
	mapStore: MapStore;
};

const context = createContext<MapStoreContext | null>(null);

export function useMapStoreContext(): MapStoreContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useMapStoreContext must be used within a MapStoreContextProvider');
	}

	return contextValue;
}

export const MapStoreContextConsumer = context.Consumer;
export const MapStoreContextProvider = context.Provider;
